export enum MccPopulationRewardingStructure {
    DefaultSponsorSetting = 'DefaultSponsorSetting',
    EnableMCCMultiYearCompliance = 'EnableMCCMultiYearCompliance',
    DisableMCCMultiYearCompliance = 'DisableMCCMultiYearCompliance',
    RewardWhenActionCompletedInCalendarYear = 'RewardWhenActionCompletedInCalendarYear',
    RewardWhenActionCompletedInProgramYear = 'RewardWhenActionCompletedInProgramYear'
}

export const MccRewardingStructureDropdownOptions = [
    { name: MccPopulationRewardingStructure.DefaultSponsorSetting, value: 'Default - Use Sponsor Setting' },
    { name: MccPopulationRewardingStructure.EnableMCCMultiYearCompliance, value: 'Enable MCC Multi-Year Compliance' },
    { name: MccPopulationRewardingStructure.DisableMCCMultiYearCompliance, value: 'Disable MCC Multi-Year Compliance' },
    { name: MccPopulationRewardingStructure.RewardWhenActionCompletedInCalendarYear, value: 'Reward When Action Completed in Calendar Year' },
    { name: MccPopulationRewardingStructure.RewardWhenActionCompletedInProgramYear, value: 'Reward When Action Completed in Program Year' }
];
